// Source of the PERCENT_REG – https://github.com/angular/angular/pull/14318
export function encodeSinglePercentCharacterInGetParams(url: string): string {
    const urlArr = url.split('?');
    const isUrlWithGetParams = urlArr[1] !== undefined;

    if (isUrlWithGetParams === false) {
        return url;
    } else {
        const PERCENT_REG = /(?!%[0-9A-Fa-f]{2})%/g;
        const PERCENT_ENCODED_CHAR = '%25';

        urlArr[1] = urlArr[1].replace(PERCENT_REG, PERCENT_ENCODED_CHAR);
        return urlArr.join('?');
    }
}

export function addSlashToEndOfPathnameInUrl(url: string): string {
    const separatorPattern = new RegExp('[#?]', 'g');
    const separatorPosition = url.search(separatorPattern);
    const separator = url[separatorPosition];
    const pathArr = url.split(separator);

    pathArr[0] += pathArr[0].endsWith('/') ? '' : '/';
    return pathArr.join(separator);
}
